import { Button, Input, PageHeader, Spin } from 'antd'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CreateConfigTimeWorkRequest, UpdateConfigTimeWorkRequest } from '@/types/apis/config'
import { TimeWork } from '@/types/apis/config/GetConfigTimeWorkResponse'

import { TitleConfig, WrapperButton, WrapperInput } from './styles'

type Props = {
  createConfigTime: (request: CreateConfigTimeWorkRequest) => Promise<void>
  getConfigResponse: TimeWork | undefined
  updateConfigTime: (request: UpdateConfigTimeWorkRequest) => Promise<void>
  timeConfig: number | undefined
  getConfigTime: () => Promise<void>
  loading: boolean
}

const ConfigPageHeader: FC<Props> = ({
  createConfigTime,
  getConfigResponse,
  updateConfigTime,
  getConfigTime,
  loading,
}) => {
  const { t } = useTranslation()
  const [timeWork, setTimeWork] = useState<number>()
  const [versionApp, setVersionApp] = useState<string>('')

  const handleSubmit = async () => {
    if (timeWork) {
      if (getConfigResponse) {
        await updateConfigTime({ timeExists: timeWork, versionApp })
        await getConfigTime()
        return
      }
      await createConfigTime({ timeExists: timeWork })
      await getConfigTime()
    }
  }

  useEffect(() => {
    if (getConfigResponse) {
      setTimeWork(getConfigResponse.timeExists)
      setVersionApp(getConfigResponse.versionApp)
    }
  }, [getConfigResponse])

  return (
    <Spin spinning={loading}>
      <PageHeader ghost={false} title={t('components.pages.config.title')} />
      <div>
        <WrapperInput>
          <TitleConfig>{t('components.pages.config.header')}</TitleConfig>
          <Input type="number" width={'100%'} value={timeWork} onChange={(e) => setTimeWork(Number(e.target.value))} />
        </WrapperInput>

        <WrapperInput>
          <TitleConfig>{t('components.pages.config.versionApp')}</TitleConfig>
          <Input value={versionApp} onChange={(e) => setVersionApp(e.target.value)} />
        </WrapperInput>
        <WrapperButton>
          <Button onClick={handleSubmit}>{t('components.pages.config.save')}</Button>
        </WrapperButton>
      </div>
    </Spin>
  )
}

ConfigPageHeader.displayName = 'ConfigPageHeader'
export default ConfigPageHeader
